import { render, staticRenderFns } from "./ShopSearch.vue?vue&type=template&id=875d935c"
import script from "./ShopSearch.vue?vue&type=script&lang=js"
export * from "./ShopSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('875d935c')) {
      api.createRecord('875d935c', component.options)
    } else {
      api.reload('875d935c', component.options)
    }
    module.hot.accept("./ShopSearch.vue?vue&type=template&id=875d935c", function () {
      api.rerender('875d935c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ShopSearch.vue"
export default component.exports